import { filter, keys, map } from 'es-toolkit/compat';

export function enumValuesList<T extends {}>(enumToConvert: T): T[keyof T][] {
  const enumKeys = filter(keys(enumToConvert), (v) => isNaN(Number(v)));
  return map(enumKeys, (k) => enumToConvert[k as keyof T]);
}
